export enum BreakpointsKeys {
  Desktop1920 = 'desktop1920',
  Desktop1440 = 'desktop1440',
  DesktopLarge = 'desktopLarge',
  Desktop = 'desktop',
  Tablet = 'tablet',
  Mobile = 'mobile'
}

export const Breakpoints = {
  desktop1920: 1920,
  desktop1440: 1440,
  desktopLarge: 1200,
  desktop: 1024,
  tablet: 768,
  mobile: 500
};
